export const OnlineStatus = {
  ONLINE: 'online',
  OFFLINE: 'offline',
};
